import axios from '../request/http';

const activity = {
    // 活动板块列表
    activityModuleList(params) {
        return axios.get("/admin/activity-module/list", {params});
    },
    // 活动模板修改
    activityModuleEdit(data) {
        return axios.post("/admin/activity-module/addOrUpdate", data);
    },
    // 活动商品列表
    activityModuleGoodsList(params) {
        return axios.get("/admin/activity-module/goods/list", {params});
    },
    // 活动商品规格
    activityModuleGoodsSpecList(params) {
        return axios.get("/admin/activity-module/goods/spec/list", {params});
    },
    // 商品规格信息活动价格修改
    activityModuleGoodsaddOrUpdate(data) {
        return axios.post("/admin/activity-module/goods/addOrUpdate", data);
    },
    // 商品排序
    activityModuleGoodsUpdate(data) {
        return axios.post("/admin/activity-module/goods/update", data);
    },
    // 活动商品批量新增
    activityModuleGoodsBatchAdd(data) {
        return axios.post("/admin/activity-module/goods/batchAdd", data);
    },
    // 活动专区删除
    activityModuleGoodsBatchDel(params) {
        return axios.get("/admin/activity-module/addOrUpdate", {params});
    },
}

export default activity;


// WEBPACK FOOTER //
// ./src/api/activity.js